"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSubscriptionDetailsData = void 0;
const zod_1 = require("zod");
// getSubscriptionDetails
// Data
const GetSubscriptionDetailsDataSchema = zod_1.z.object({
    planId: zod_1.z.string(),
});
const validateSubscriptionDetailsData = (x) => GetSubscriptionDetailsDataSchema.safeParse(x);
exports.validateSubscriptionDetailsData = validateSubscriptionDetailsData;
//# sourceMappingURL=subscriptions.js.map